
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
// import ModalDeleteTech from "./ModalDeleteTech";
import { useState, useEffect, useRef, Fragment } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import './styles/alerts.css'
import MenuAlert from "../../MenuAlert";


// import ModalMsgError from "./ModalMsgError";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    height: '20%',
    padding: '20px'
  },
};
const msgErrorModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    height: '40%',
    padding: '20px'
  },
};
const EventsList = ({
  pageActual,
  limitList, startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup,
  setImportModalOpen,
  userPermissions,
  dataAgencies,
  origen,
  setSuveryId,
  ubiActual,
  buscar_cis,
  loadingList,
  props
}) => {
  // const dataUsers=useFetch('cassia/ci','',localStorage.getItem('access_token'),'GET',server)

  // var dataList=(searchTerm==='')?dataUsers.data:searchResults;
  // console.log(dataList);
  // console.log("intervalo de resultados", pageActual, limitList);
  const [deleteUserModalOpen, setDeleteUserModalOpen] = useState(false);
  const [userSelected, setUserSelected] = useState({})
  const [msgErrorModalOpen, setMsgErrorModalOpen] = useState(false);
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  function openMsgErrorModal() {
    setMsgErrorModalOpen(true);
  }

  function closMsgErrorModal() {

    setMsgErrorModalOpen(false);
  }
  const handledeleteUserClick = (data) => {

    openMsgErrorModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  function cambiarFormatoFecha(fechaEnFormatoMMDDYYYY) {
    const partes = fechaEnFormatoMMDDYYYY.split('/');
    const fechaEnFormatoYYYYMMDD = `${partes[2]}-${partes[1]}-${partes[0]}`;
    return fechaEnFormatoYYYYMMDD;
  }


  const calcularDiferenciaTiempo = (fechaDada, horaDada) => {
    // Convertir la fecha y hora dadas a objetos Date
    // const fechaHoraDadas = new Date(`${cambiarFormatoFecha(fechaDada)}T${horaDada}`);
    const fechaHoraDadas = new Date(`${fechaDada}T${horaDada}`)
    // Obtener la fecha y hora actuales
    const fechaHoraActual = new Date();
    // Calcular la diferencia en milisegundos
    const diferenciaEnMilisegundos = fechaHoraDadas - fechaHoraActual;
    // Calcular la diferencia en minutos y horas
    const minutos = Math.floor(Math.abs(diferenciaEnMilisegundos) / (1000 * 60));
    const horas = Math.floor(minutos / 60);
    const dias = Math.floor(horas / 24);
    const txtHrs = horas - (dias * 24)
    const txtMin = minutos - (horas * 60)
    const response = ((dias >= 1) ? dias + ' dias ' : '') + ((txtHrs >= 1) ? txtHrs + ' hrs ' : '') + ((txtMin >= 1) ? txtMin + ' min' : '')
    return response;
  };
  // useEffect(() => {
  //   console.log("auditoria")
  //   // buscar_cis();
  // }, []);
  // const buscar_cis = () => {
  //   // setLoadingCis(true)
  //   const data={
  //     start_date :'2024-01-01T00:00:00',
  //     end_date :'2024-12-31T23:59:59',
  //     user_email:'',
  //     module_id:''
  //   }
  //   const fetchDataPost = async () => {
  //     try {
  //       let baseURL=''
  //       baseURL = server.url+'/api/v1/cassia/audit/';
  //       const start_date  = '?start_date='+data.start_date
  //       const end_date = '&end_date='+data.end_date
  //       const user_email = (data.user_email=="")?'':'&user_email='+data.user_email
  //       const module_id = (data.module_id=="")?'':'&user_email='+data.module_id

  //       const url=baseURL+start_date+end_date+user_email+module_id
  //       // console.log(url)  
  //       const response = await fetch(
  //         url,
  //         {
  //           method: "GET",
  //           headers: {
  //             "Content-Type": "application/json",
  //             accept: "application/json",
  //             Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  //           },
  //         }
  //       );

  //       console.log(response);
  //       if (response.ok) {
  //         const data1 = await response.json();
  //         // setLoadingCis(false)
  //         console.log(data1);
  //         setDataUsers(data1);
  //         // setCreateCisModalOpen(true)
  //       } else {
  //         const data1 = await response.json();
  //         console.log(data1);
  //         throw new Error("Error en la solicitud");
  //       }
  //     } catch (error) {
  //       console.error(error);
  //     }
  //   };

  //   fetchDataPost();
  // };

  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };
  function simplifyDuration(durationStr) {
    // Expresiones regulares para capturar días, horas y minutos
    const regex = /(\d+)\s*dias?|\s*(\d+)\s*hrs?|\s*(\d+)\s*min/g;
    let days = 0, hours = 0, minutes = 0;

    // Buscar coincidencias
    durationStr.replace(regex, (_, d, h, m) => {
      if (d) days = parseInt(d);
      if (h) hours = parseInt(h);
      if (m) minutes = parseInt(m);
      return "";
    });

    // Construir salida solo con valores > 0
    const parts = [];
    if (days > 0) parts.push(`${days} dia${days > 1 ? "s" : ""}`);
    if (hours > 0) parts.push(`${hours} hr${hours > 1 ? "s" : ""}`);
    if (minutes > 0) parts.push(`${minutes} min`);

    // Si todo es 0, devolver "0 min"
    return parts.length > 0 ? parts.join(" ") : "0 min";
  }
  const [menuAlertOpen, setMenuAlertOpen] = useState(false);
  const openMenuAlert = (e) => {
    // buscar_info(data.eventid)
    // console.log(e)
    handleSelected(e)
    // console.log(data.longitude)
    // console.log(ubicacion.groupid)
    // setUbicacion({latitud:data.latitude.replace(",", "."),longitud:data.longitude.replace(",", "."),zoom:16,groupid:ubicacion.groupid,dispId:ubicacion.dispId,templateId: ubicacion.templateId})
    setMenuAlertOpen(true);
  };
  const handleSelected = (element) => {

    // console.log(element)
    setUserSelected(element)

  }
  const closeMenuAlert = () => {

    setMenuAlertOpen(false);
  };
  const [selectedEventId, setSelectedEventId] = useState(null);
  const clickRow = (e) => {

    if (menuAlertOpen) {
      setSelectedEventId(null);
      closeMenuAlert()
    } else {
      setSelectedEventId(e.eventid);
      openMenuAlert(e)
    }
    // closeMenuAlert:openMenuAlert
  }
  function getColorById(id) {
    const agency = dataAgencies.data.data.find(agency => agency.id === id);
    return agency ? agency.color : null;
  }
  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0 });
  const knownEventIdsRef = useRef(new Set());
  const [flashingEvents, setFlashingEvents] = useState(new Set());

  useEffect(() => {
    if (!dataList || dataList.length === 0) return;

    const newlyAdded = [];
    if (knownEventIdsRef.current.size > 0) {
      dataList.forEach(item => {
        if (!knownEventIdsRef.current.has(item.eventid)) {
          newlyAdded.push(item.eventid);
        }
      });
    }

    dataList.forEach(item => {
      knownEventIdsRef.current.add(item.eventid);
    });

    if (newlyAdded.length > 0) {
      setFlashingEvents(prev => {
        const next = new Set(prev);
        newlyAdded.forEach(id => next.add(id));
        return next;
      });

      setTimeout(() => {
        setFlashingEvents(prev => {
          const next = new Set(prev);
          newlyAdded.forEach(id => next.delete(id));
          return next;
        });
      }, 30000);
    }
  }, [dataList]);

  const handleMouseMove = (e) => {
    setTooltip({
      visible: true,
      x: e.clientX + 10, // un poco a la derecha del cursor
      y: e.clientY + 10, // un poco abajo del cursor
    });
  };

  const handleMouseLeave = () => {
    setTooltip((t) => ({ ...t, visible: false }));
  };
  return (
    <>
      <div className="cont-row-user-list">
        {loadingList ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <Fragment key={elemento.eventid || indice}>
                <div
                  className={`mh-alert-row tooltip-container ${selectedEventId === elemento.eventid ? 'mh-alert-row-active' : ''} ${((flashingEvents.has(elemento.eventid) && elemento.Estatus === 'PROBLEM' && (elemento.acknowledges_concatenados == null || elemento.acknowledges_concatenados == "")) ? 'critical-row ' : '')}`}
                  style={{ height: '60px !important' }}
                  onClick={() => { clickRow(elemento) }}
                  onMouseMove={handleMouseMove}
                  onMouseLeave={handleMouseLeave}
                >
                  {/* <div className="field-body-table-mantenimiento field-small">
                 <div className='cont-checkbox'>
                 <input type='checkbox' checked={poolRows.some((row) => row === elemento.eventid)}  className='NotifiCheckBox ' style={{height:'15px'}}  onClick={()=>rowSelected(elemento)} ></input>
                </div>
                </div> */}
                  <div className="mh-alert-cell" style={{ overflow: 'unset', width:'3%' }}>
                    {
                      (origen == 'to-do') ? <div className='cont-checkbox'>
                        <input onClick={(e) => e.stopPropagation()}  // evita el click del padre
                          onChange={() => rowSelected(elemento)} type='checkbox' checked={poolRows.some((row) => row === elemento.eventid)} className='NotifiCheckBox ' style={{ height: '15px' }}  ></input>
                      </div> : ((elemento.user_to_do_id != 0 && elemento.user_to_do_id != null) ?
                        <div className={'icon-user-contaner'} style={{ border: '1px solid white', fontSize: 'x-small', fontWeight: 'bold', borderRadius: '50%', width: '25px', height: '25px', background: getColorById(elemento.exception_agency_id), display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                          <img src={'/iconos/user_warning.png'} className={'iconAgencyProblem'} alt="Logo"></img>
                          <span className="tooltip-text">{elemento.user_to_do_name}</span>
                        </div> :
                        <div className='cont-checkbox'>
                          <input type='checkbox' onClick={(e) => e.stopPropagation()}  // evita el click del padre
                            onChange={() => rowSelected(elemento)} checked={poolRows.some((row) => row === elemento.eventid)} className='NotifiCheckBox ' style={{ height: '15px' }}   ></input>
                        </div>)
                    }
                  </div>
                  <div className="mh-alert-cell" style={{ width:'4%' }}>
                    {elemento.eventid}
                  </div>
                  <div className="mh-alert-cell" style={{ width:'6%' }}>
                    {elemento.severity}
                  </div>
                  <div className="mh-alert-cell" style={{ width: '20%' }} >
                    {elemento.Problem.length > 25 ? `${elemento.Problem.slice(0, 25)}...` : ((elemento.Problem.includes("Unavailable by ICMP ping")) ? "CASSIA detecto DESCONEXIÓN en:" : elemento.Problem)}
                  </div>
                  <div className="mh-alert-cell" style={{ width: '20%' }}>
                    {elemento.Host}
                  </div>


                  <div className="mh-alert-cell" style={{ width:'8%' }} >
                    {
                      (flashingEvents.has(elemento.eventid) && elemento.Estatus === 'PROBLEM' && (elemento.acknowledges_concatenados == null || elemento.acknowledges_concatenados == "")) ?
                        <div className="cell"><span className="mh-alert-status mh-status-problem status-chip problem">PROBLEM</span></div> : 
                        <span className={`mh-alert-status ${elemento.Estatus == 'RESOLVED' ? 'mh-status-resolved' : 'mh-status-problem'}`}>
                          {elemento.Estatus}
                        </span>
                    }
                  </div>

                  <div className="mh-alert-cell" style={{ width:'4%' }} >
                    {(elemento.tipo == 1 && (elemento.item_key == 'icmpping' || elemento.alert_type == 'correlation')) ? 'ODD' : 'DDT'}
                  </div>
                  <div className="mh-alert-cell" style={{ width:'4%' }} >
                    {elemento.dependents}
                  </div>
                  <div className="mh-alert-cell" style={{ width:'4%' }}  >
                    <div className='pointProblemCell'>
                      {
                        (elemento.acknowledges_concatenados != null && elemento.acknowledges_concatenados != "") ? <div className='centerPoint'></div> : ''
                        // (elemento.Ack_message!=null && elemento.Ack_message!="")? <div className='centerPoint'></div>:''
                      }
                    </div>

                  </div>
                  <div className="mh-alert-cell" style={{ width:'5%', color: elemento.status == 'error' ? 'red' : 'green' }} >
                    <div className='pointProblemCell'>
                      {
                        ((elemento.ticket_id == null || elemento.ticket_id == "") && (elemento.ticket_status == null || elemento.ticket_status == "")) ? '' : <div className='centerPoint' style={{ background: (elemento.ticket_status == 'creado') ? 'var(--green)' : ((elemento.ticket_status == 'error') ? 'red' : 'yellow') }}></div>
                      }
                    </div>
                  </div>
                  <div className="mh-alert-cell" style={{ width:'4%' }} >
                    {
                      (elemento.sla == null || elemento.sla == "") ? "N/A" : elemento.sla
                    }
                  </div>
                  <div className="mh-alert-cell" style={{ width:'7%' }} >
                    {simplifyDuration(elemento.diferencia)}
                    {/* {calcularDiferenciaTiempo(cambiarFormatoFecha(elemento.Time.slice(0,10)), elemento.Time.slice(-8))} */}
                  </div>
                  <div className="mh-alert-cell" style={{ width:'7%' }} >
                    {simplifyDuration(elemento.tiempo_ultima_caida)}
                  </div>
                  <div className="mh-alert-cell" style={{ width:'7%' }} >
                    {elemento.Time}
                  </div>
                  {<div className="tooltip-content" onClick={(e) => e.stopPropagation()} style={{
                    left: '50%', width: 'auto', minWidth: '20%', maxWidth: '50%', boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.34)', padding: '10px', borderRadius: '5px', zIndex: 1000, overflowY: 'auto', maxHeight: '250px', position: "fixed", background: 'var(--white-color)', color: 'var(--txt-color)',
                    top: tooltip.y,
                    left: tooltip.x
                  }}>
                    {(elemento.alert_type != 'correlation') ?
                      <>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                          <div style={{ fontWeight: 'bold' }}>ip:</div>
                          <div>{elemento.ip} </div>
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                          <div style={{ fontWeight: 'bold' }}>{capitalizeFirstLetter(lang[languaje]['afiliacion'])}:</div>
                          <div>{elemento.affiliation} </div></div>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                          <div style={{ fontWeight: 'bold' }}>{capitalizeFirstLetter(lang[languaje]['Incidencia'])}:</div><br></br>
                          <div>{elemento.Problem} </div></div>
                      </> :
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                        <div style={{ fontWeight: 'bold' }}>{capitalizeFirstLetter(lang[languaje]['eventoCorrelacionado'])}:</div>
                        <div>{elemento.Problem} </div></div>
                    }

                    {(elemento.Ack_message != '' && elemento.Ack_message != null) ? <>
                      <p style={{ fontWeight: 'bold' }}>Ack:</p>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>{elemento.Ack_message} </div></> : ''}
                    {
                      (elemento.correlation_info != null && elemento.correlation_info != "") ? <> <br></br>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px' }}>
                          <div style={{ fontWeight: 'bold' }}>{elemento.correlation_info_array.length} eventos correlacionados:</div>
                          <div style={{ color: 'red' }}>{elemento.correlation_info_array.filter(elemento => elemento.status === 'PROBLEM').length} PROBLEM</div>
                          <div style={{ color: 'green' }}>{elemento.correlation_info_array.filter(elemento => elemento.status === 'RESOLVED').length} RESOLVED</div>
                          {/* <img
                                            src={
                                              "/iconos/info.png"
                                            } 
                                            name="info"  title='info' className="btnAction delteException" style={{width:'35%'}} onClick={()=>handledeleteUserClick(elemento)}
                                          /> */}
                        </div>
                        {elemento.correlation_info_array.map((e, x) => (
                          <div key={x}><div style={{ color: (e.status == 'PROBLEM' ? 'red' : 'green') }}>{e.eventid} &nbsp;/ &nbsp;{e.host} &nbsp;/&nbsp;{e.status} </div></div>
                        ))
                        }</> : <></>
                    }

                  </div>}
                </div>
                {selectedEventId === elemento.eventid && (
                  <MenuAlert
                    languaje={languaje}
                    setImportModalOpen={setImportModalOpen}
                    setSuveryId={setSuveryId}
                    handleShowPopup={handleShowPopup}
                    setSearchTerm={setSearchTerm}
                    ubiActual={ubiActual}
                    server={server}
                    ackMessage={'ackMessage'}
                    isOpen={true} // Se asume que si se renderiza, está abierto
                    props={{ data: userSelected, server: server, languaje: languaje, mode: mode, dataAgencies: dataAgencies, userPermissions: userPermissions, handleShowPopup: handleShowPopup }}
                    onClose={closeMenuAlert}
                  />
                )}

              </Fragment>
            ))
        )}
        {dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>


    </>
  );
};

export default EventsList;
